<template>
  <div class="wrap">
    <div class="upload-card">
      <span class="date" v-if="dateTime">{{ dateTime }}</span>
      <upload :isMultiple="false" v-model="response" />
      <img v-if="picture" class="bg-card"
        src="https://hzwimspic-1251601690.image.myqcloud.com/85fdfdee-0fbc-4db9-81a4-0f6de14758a1_size_328x88" alt="">
      <div v-if="!picture" class="upload-plus">
        <img src="https://hzwimspic-1251601690.image.myqcloud.com/536d7137-4fac-4777-897f-014d98f563f3_size_52x52"
          alt="">
      </div>
      <img v-else class="upload-pic" :src="picture" alt="" />
      <div v-if="!picture" class="upload-tip">上传今日服务记录</div>
      <img v-else class="upload-edit"
        src="https://hzwimspic-1251601690.image.myqcloud.com/2dfd4e26-a232-4aeb-92c0-92f2d473fc16_size_318x115"
        alt="" />
    </div>
    <div class="submit" @click="submit">提交</div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import upload from '@/components/common/comment/add/upload/index.vue'
import { addServiceLog } from '../service'

export default {
  data() {
    return {
      picture: '',
      dateTime: '',
      response: {},
      reupload: false
    }
  },
  watch: {
    response(value) {
      if (value.code === 5) {
        this.reupload = false
        this.picture = value.pic.dataPic
      }
    },
    pic(value) {
      this.rest = this.max - value.length
    }
  },
  components: {
    upload
  },
  computed: {
  },
  created() {
    this.$$title('上传')
    this.dateTime = this.$route.query.logDate || ''
    //重新格式化日期yyyy-mm-ddw为yyyy年mm月dd日
    if (this.dateTime.length > 0) {
      this.dateTime = dayjs(this.dateTime).format('YYYY年MM月DD日')
    }

    this.picture = ''
    this.$$loading(false)
  },
  async mounted() {
  },
  methods: {
    submit() {
      if (!this.picture) {
        this.$$toast('请上传服务记录图片')
        return
      }
      this.$$loading(true)
      addServiceLog({
        logDate: this.$route.query.logDate,
        pics: this.picture,
        orderId: this.$route.query.orderId
      }).then((res) => {
        this.$$loading(false)
        this.$$toast('服务记录添加成功')
        this.$router.go(-1)
      }).catch((err) => {
        this.$$loading(false)
        this.$$toast(err)
      })

    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';

.wrap {
  background-color: #f5f5f5;
}


.upload-card {
  position: absolute;
  top: rem(24px);
  left: rem(24px);
  width: rem(702px);
  height: rem(440px);
  background: #fff;
  border-radius: rem(28px);
  padding: rem(32px) 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.bg-card {
  position: absolute;
  top: rem(136px);
  left: rem(187px);
  width: rem(328px);
  height: rem(88px);
}

.date {
  position: absolute;
  top: rem(28px);
  left: rem(32px);
  color: #121212;
  font-size: rem(32px);
  font-weight: 600;
}

.upload-plus {
  width: rem(160px);
  height: rem(160px);
  border: rem(2px) dashed #DEE5F4;
  border-radius: rem(20px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(137.81deg, #f5fbff -14.11%, #fbf5ff 94.34%);

  img {
    width: rem(80px);
    height: rem(80px);
  }
}

.upload-pic {
  width: rem(180px);
  height: rem(180px);
  border-radius: rem(20px);
}

.upload-tip {
  margin-top: rem(28px);
  font-size: rem(28px);
  color: #121212;
}

.upload-edit {
  margin-top: rem(23px);
  width: rem(166px);
  height: rem(54px);
  object-fit: cover;
}

.submit {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: rem(24px);
  left: rem(24px);
  width: rem(702px);
  height: rem(80px);
  mix-blend-mode: normal;
  border-radius: rem(40px);
  background: linear-gradient(90deg, #fe397e 0%, #ff074c 100%);
  font-weight: 600;
  font-size: rem(32px);
  color: #fff;
}

.ui-upload-img,
.kidswant-upload {
  position: absolute;
  z-index: 4;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  font-size: 0;
  opacity: 0;
}
</style>
